import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    AccountNewCustomerModel,
    AccountNewCustomerParameter,
    getAccountNewCustomer,
} from "@tSurya/Services/AccountNewCustomerService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<AccountNewCustomerParameter, AccountNewCustomerModel>;

export const DispatchBeginNewCustomer: HandlerType = props => {
    props.dispatch({
        type: "Custom/NewCustomer/BeginLoadNewCustomer",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getAccountNewCustomer(props.apiParameter);
};

export const DispatchCompleteNewCustomer: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/NewCustomer/CompletedLoadNewCustomer",
        result: props.apiResult,
    });
};

export const chain = [DispatchBeginNewCustomer, PopulateApiParameter, RequestDataFromApi, DispatchCompleteNewCustomer];

const loadNewCustomer = createHandlerChainRunner(chain, "loadNewCustomer");
export default loadNewCustomer;
